import { ACTIVITY_SECTIONS } from 'constants/enums'
import mapAwardCategories from 'helpers/mapAwardCategories'
import { isEmpty } from 'lodash'

const COMPLETION = 'dofe-fo/residentialProject/COMPLETION'
const COMPLETION_SUCCESS = 'dofe-fo/residentialProject/COMPLETION_SUCCESS'
const COMPLETION_FAIL = 'dofe-fo/residentialProject/COMPLETION_FAIL'

const SETUP = 'dofe-fo/residentialProject/SETUP'
const SETUP_SUCCESS = 'dofe-fo/residentialProject/SETUP_SUCCESS'
const SETUP_FAIL = 'dofe-fo/residentialProject/SETUP_FAIL'

const APPROVAL = 'dofe-fo/residentialProject/APPROVAL '
const APPROVAL_SUCCESS = 'dofe-fo/residentialProject/APPROVAL_SUCCESS '
const APPROVAL_FAIL = 'dofe-fo/residentialProject/APPROVAL_FAIL '

const GET_DETAIL = 'react-template/residentialProject/GET_DETAIL'
const GET_DETAIL_SUCCESS =
  'react-template/residentialProject/GET_DETAIL_SUCCESS'
const GET_DETAIL_FAIL = 'react-template/residentialProject/GET_DETAIL_FAIL'

const GET_CATEGORIES = 'dashboard/residentialProject/GET_CATEGORIES'
const GET_CATEGORIES_SUCCESS =
  'dashboard/residentialProject/GET_CATEGORIES_SUCCESS'
const GET_CATEGORIES_FAIL = 'dashboard/residentialProject/GET_CATEGORIES_FAIL'

const CRUD = 'dashboard/residentialProject/CRUD'
const CRUD_SUCCESS = 'dashboard/residentialProject/CRUD_SUCCESS'
const CRUD_FAIL = 'dashboard/residentialProject/CRUD_FAIL'

const initialState = {
  completion: {
    loading: false,
    loaded: false
  },
  setup: {
    loading: false,
    loaded: false
  },
  revise: {
    loaded: false,
    data: null
  },
  approval: {
    loading: false,
    loaded: false
  },
  data: null,
  detail: {}
}

export default function residentialProject(state = initialState, action = {}) {
  switch (action.type) {
    case COMPLETION:
      return {
        ...state,
        completion: {
          ...state.completion,
          loading: true
        }
      }

    case COMPLETION_SUCCESS:
      return {
        ...state,
        completion: {
          ...state.completion,
          loading: false,
          loaded: true,
          error: null
        }
      }

    case COMPLETION_FAIL:
      return {
        ...state,
        completion: {
          ...state.completion,
          loading: false,
          loaded: false,
          error: action.error
        }
      }

    case SETUP:
      return {
        ...state,
        setup: {
          ...state.setup,
          loading: true
        }
      }

    case SETUP_SUCCESS:
      return {
        ...state,
        setup: {
          ...state.setup,
          loading: false,
          loaded: true,
          error: null
        }
      }

    case SETUP_FAIL:
      return {
        ...state,
        setup: {
          ...state.setup,
          loading: false,
          loaded: false,
          error: action.error
        }
      }

    case APPROVAL:
      return {
        ...state,
        approval: {
          ...state.approval,
          loading: true
        }
      }

    case APPROVAL_SUCCESS:
      return {
        ...state,
        approval: {
          ...state.approval,
          loading: false,
          loaded: true,
          error: null
        }
      }

    case APPROVAL_FAIL:
      return {
        ...state,
        approval: {
          ...state.approval,
          loading: false,
          loaded: false,
          error: action.error
        }
      }

    case GET_CATEGORIES_SUCCESS:
      return {
        ...state,
        error: null,
        categories: !isEmpty(action.result)
          ? mapAwardCategories(action.result)
          : []
      }

    case GET_CATEGORIES_FAIL:
      return {
        ...state,
        error: action.error
      }

    case GET_DETAIL:
      return {
        ...state,
        loading: true
      }

    case GET_DETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        error: null,
        detail: action.result
      }

    case GET_DETAIL_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }

    default:
      return state
  }
}

export function setupRP(rPID, data) {
  return {
    types: [SETUP, SETUP_SUCCESS, SETUP_FAIL],
    promise: client =>
      client.post(`api/residential-projects/${rPID}/setup`, { data })
  }
}

export function editRP(rPID, data) {
  return {
    types: [SETUP, SETUP_SUCCESS, SETUP_FAIL],
    promise: client =>
      client.post(`api/residential-projects/${rPID}/edit`, { data })
  }
}

export function getRPCategories() {
  const params = {
    filter: `filter=activitySection.value=${
      ACTIVITY_SECTIONS.residential_project.id
    }`
  }

  return {
    types: [GET_CATEGORIES, GET_CATEGORIES_SUCCESS, GET_CATEGORIES_FAIL],
    promise: client => client.get(`api/activity-categories?${params.filter}`)
  }
}

export function getRPDetail(rPID) {
  return {
    types: [GET_DETAIL, GET_DETAIL_SUCCESS, GET_DETAIL_FAIL],
    promise: client => client.get(`api/residential-projects/${rPID}?with=APPEND_CUSTOMIZATIONS,ASSESSOR_REGISTRATION_DATA,ORGANIZATION,ASSESSOR_REGISTRATION,ASSESSOR`)
  }
}

export function completionRP(rPID, data) {
  return {
    types: [COMPLETION, COMPLETION_SUCCESS, COMPLETION_FAIL],
    promise: client =>
      client.post(`api/residential-projects/${rPID}/completions`, { data })
  }
}

export function sendAssessmentRequest(rPID, data) {
  return {
    types: [APPROVAL, APPROVAL_SUCCESS, APPROVAL_FAIL],
    promise: client =>
      client.post(`api/residential-projects/${rPID}/assessment-requests`, {
        data
      })
  }
}

export function sendLeaderRequest(rPID, data) {
  return {
    types: [APPROVAL, APPROVAL_SUCCESS, APPROVAL_FAIL],
    promise: client =>
      client.post(
        `api/residential-projects/${rPID}/award-leader-signoff-requests`,
        { data }
      )
  }
}

export function rpAssessorRejection(rPID, data) {
  return {
    types: [CRUD, CRUD_SUCCESS, CRUD_FAIL],
    promise: client =>
      client.post(`api/residential-projects/${rPID}/assessor-rejections`, {
        data
      })
  }
}
